import { observer } from 'mobx-react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import EmptyStateReadingPane from './EmptyStateReadingPane';
import UnsupportedItemReadingPane from './UnsupportedItemReadingPane';
import readingPaneStore from 'owa-mail-reading-pane-store/lib/store/Store';
import * as React from 'react';

const styles = require('./ReadingPane.scss');

const ConversationReadingPaneInfoPage = () => {
    const selectedConversationReadingPaneState = readingPaneStore.conversationReadingPaneViewState;
    if (
        !selectedConversationReadingPaneState ||
        selectedConversationReadingPaneState.loadingState.isLoading
    ) {
        // Loading
        return <Spinner className={styles.loadingSpinner} />;
    } else if (selectedConversationReadingPaneState.loadingState.hasLoadFailed) {
        // Error
        return <EmptyStateReadingPane isError={true} />;
    } else if (selectedConversationReadingPaneState.unsupportedItemId) {
        return (
            <UnsupportedItemReadingPane
                itemId={selectedConversationReadingPaneState.unsupportedItemId}
            />
        );
    }
    return null;
};

export default observer(ConversationReadingPaneInfoPage);
